import { render, staticRenderFns } from "./MultiEnrolmentFomPopup.vue?vue&type=template&id=5240e92b&scoped=true&"
import script from "./MultiEnrolmentFomPopup.vue?vue&type=script&lang=js&"
export * from "./MultiEnrolmentFomPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5240e92b",
  null
  
)

export default component.exports